/**
 * Based on src/json/defaultTags.json
 * @todo: replace above json with TS objects
 */
export enum IconTypes {
  walkIn = 'walkIn',
  add = 'add',
  addCircle = 'addCircle',
  standbyList = 'standbyList',
  phone = 'phone',
  phoneInTalk = 'phoneInTalk',
  mail = 'mail',
  lock = 'lock',
  unlock = 'unlock',
  tick = 'tick',
  loading = 'loading',
  autoRenewIcon = 'autoRenewIcon',
  // payment = 'payment',
  // preAuth = 'pre-auth',
  // cardsDiamond = 'cards-diamond',
  // birthday = 'birthday',
  // accessibility = 'accessibility',
  // anniversary = 'anniversary',
  // allergy = 'allergy',
  // highchair = 'highchair',
  // children = 'children',
  // pram = 'pram',
  // dietary = 'dietary',
  // briefcase = 'briefcase',
  // engagement = 'engagement'







  /**
   * DESIGN-V2
   */
  timer = 'timer',
  /**
   * Menu list
   */
  bookings = 'bookings',
  customers = 'customers',
  reports = 'reports',
  new = 'new',
  settings = 'settings',
  admin = 'admin',
  fullScreen = 'fullScreen',
  /**
   * Stepper
   */
  stepperLeft = 'stepperLeft',
  stepperRight = 'stepperRight',

  /*
    customer tab
  */
  callOutlinedIcon = 'callOutlinedIcon',
  accountBoxOutlinedIcon = 'accountBoxOutlinedIcon',
  mailOutlineIcon = 'mailOutlineIcon',
  visibilityOutlinedIcon = 'visibilityOutlinedIcon',

  /**
   * Booking Summary
   */
   dateRangeIcon = 'dateRangeIcon',
   scheduleIcon = 'scheduleIcon',
   //accountBoxOutlinedIcon : look customer tab
   restaurantIcon = 'restaurantIcon',
   timerIcon = 'timerIcon',
   eventSeatIcon = 'eventSeatIcon', // mat v4 has no icon of design for table
   localOfferOutlinedIcon = 'localOfferOutlinedIcon',
}
